



























import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import openbitlab from '@/types.d';
import { filter, values, get } from 'lodash';
import ToolsAndServices from '@/components/SingleNetwork/ToolsAndServices.vue';

@Component({
  components: {
    ToolsAndServices,
  },
})
export default class SingleNetworkView extends Vue {
  @State('projects') projects!: openbitlab.RootState['projects']

  getProject(id: string) {
    return this.projects[id];
  }

  // eslint-disable-next-line class-methods-use-this
  getLogoPath(id: string): string {
    const avatar = get(this.projects[id], 'logo', 'none.png');
    return `/data/logos/${avatar}`;
  }
}
